import {events}      from "../../commun/backbone/decorators";
import LoginBaseView from "./login-base-view";

@events({
            'click #btn-submit': '_onClickButton',
            'input input#login-username, input#login-email' : '_onInputChange',
            'change input#login-username, input#login-email' : '_onInputChange',
        })
class ResetExtranetPasswordView extends LoginBaseView
{
    initialize(options)
    {
        super.initialize(options);

        this.timeoutid = null;
        this.listenTo(this.model, 'load-language', (language) => this._onLoadLanguage(language))
    }

    render()
    {
        super.render();

        this.$username = $('#login-username');
        this.$email = $('#login-email');
        this.$btnconnexion = $('#btn-submit');
        this.$defaultRep = $('#res-default');
    }

    _onInputChange(event)
    {
        $(event.target).removeClass('is-invalid');
    }


    _resetInfoMessage()
    {
        super._resetInfoMessage();
        this.$defaultRep.addClass('d-none');
    }
    _onClickButton(event)
    {
        event.preventDefault();
        this._resetInfoMessage();

        const login = this.$username.val();
        const loginOk = login.length;

        const email = this.$email.val();
        const emailOk = email.length && /^\S+@\S+$/g.test(email);

        if (!loginOk || !emailOk) {
            if (!loginOk){
                this.$username.addClass('is-invalid');
            }
            if (!emailOk){
                this.$email.addClass('is-invalid');
            }
            return;
        }

        let $btn = $(event.target);
        if (!$btn.is('button'))
            $btn = $btn.parent();
        $btn.addClass('active');

        this.model.resetPassword(login, email).then(data => {
                if (!data.message.length){
                    this.$defaultRep.removeClass('d-none');
                }
                else {
                    this._setInfoMessage(data.message);
                }
            })
            .catch((err) => {
                this._setAlertMessage(err.responseJSON.message);
            })
            .finally(()=>{
                $btn.removeClass('active');
            });
    }
}
export default ResetExtranetPasswordView;